<template>
  <div class="field">
    <div class="control has-icons-left">
      <div class="select">
        <select v-model="selected" @change="e => changeLanguage(e.target.value)" class="form-control" id="languageSelect">
          <option v-for="option in options" :value="option.value">{{ option.text }}</option>
        </select>
      </div>
      <div class="icon is-small is-left">
        <i class="fa fa-globe"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n'
  import { mapActions } from 'vuex'

  export default {
    name: 'language-switcher',
    data () {
      return {
        selected: i18n.locale,
        options: [
          {text: 'English', value: 'en_US'},
          {text: 'Français', value: 'fr_FR'}
        ]
      }
    },
    methods: mapActions([
      'changeLanguage'
    ])
  }
</script>



// WEBPACK FOOTER //
// src/components/LanguageSwitcher.vue